import {
	IListAttrs,
	IListColumnConfig,
	IListOperations,
} from '@datachain/ui-sdk/common';
import { immerable, produce } from 'immer';
import { Map } from 'immutable';

import { MarketplaceMemberEntity } from '../../core/domain/marketplace-member.entity';

export interface IConsumerListExtra
	extends IListColumnConfig<MarketplaceMemberEntity> {
	isFixed?: boolean;
	isSelectable?: boolean;
	isSearchable?: boolean;
	isInGroup?: boolean;
	isVisible?: boolean;
	canBeHidden?: boolean;
	canBeReordered?: boolean;
	canBeChosen?: boolean;
	format?: string;
	visibleIndex?: number;
}

interface IConsumerListEntity extends IListAttrs<MarketplaceMemberEntity> {
	availableColumns: Map<string, IConsumerListExtra>;
}

const entityDefaults: IConsumerListEntity = {
	elements: Map(),
	availableColumns: Map(),
};

export class ExpositionConsumerListEntity
	implements
		IConsumerListEntity,
		IListOperations<ExpositionConsumerListEntity, MarketplaceMemberEntity>
{
	private [immerable] = true;
	public elements = entityDefaults.elements;
	public availableColumns = entityDefaults.availableColumns;

	public static build(
		availableCols: Array<IConsumerListExtra>
	): ExpositionConsumerListEntity {
		const inst = new ExpositionConsumerListEntity();
		const cols = availableCols.reduce((acc, curr) => {
			acc.push([curr.field, curr]);
			return acc;
		}, new Array<[string, IConsumerListExtra]>());
		inst.availableColumns = Map(cols);
		return inst;
	}

	private constructor() {}

	public getAvailableColumns(): Map<
		string,
		IListColumnConfig<MarketplaceMemberEntity>
	> {
		return this.availableColumns;
	}
	public setElements(
		elems: Map<string, MarketplaceMemberEntity>
	): ExpositionConsumerListEntity {
		return produce(this, (draft: ExpositionConsumerListEntity) => {
			draft.elements = elems;
		});
	}

	public addConsumer(
		elem: MarketplaceMemberEntity
	): ExpositionConsumerListEntity {
		const elems = this.elements.set(`${elem.id}`, elem);
		return produce(this, (draft: ExpositionConsumerListEntity) => {
			draft.elements = elems;
		});
	}

	public removeConsumers(ids: Array<string>): ExpositionConsumerListEntity {
		const elems = this.elements.deleteAll(ids);
		return produce(this, (draft: ExpositionConsumerListEntity) => {
			draft.elements = elems;
		});
	}
}
